const FileTypesEnum = Object.freeze({
  CSV: 1,
  EXCEL: 2,
});

export default (FileTypesEnum);
